import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { useStyles } from '../../../grnReceipts/grnStyles';
import axios from 'axios';
import { appUrl } from '../../../../../../../utils/config';

const MFGPlantFilter = (props) => {
  const { handleSelectMFGPlant, selectedMFGPlantList, setMFGPlantList, setAllMFGPlantList, filteredMFGPlantList } = props;
  const classes = useStyles();
  const [mfgPlantList, setMFGPlantListLocal] = useState([]);
  const [selectedMfgPlantIds,setSelectedMfgPlantIds] = useState([])
  const [loading, setLoading] = useState(false);

  const handleSelect = (event) => {
    const value = event.target.value;
    if (value.includes("All")) {
      // Toggle: if all selected, deselect all; otherwise select all
      if (selectedMfgPlantIds.length === mfgPlantList.length) {
        setSelectedMfgPlantIds([]);
      } else {
        setSelectedMfgPlantIds(mfgPlantList.map(plant => plant.aslNumber));
      }
    } else {
      setSelectedMfgPlantIds(value);
    }

  };

  useEffect(()=>{
    if(selectedMFGPlantList.length ===0){
      setSelectedMfgPlantIds([]);
    }
  },[selectedMFGPlantList])

  useEffect(() => {
    // Fetch MFG Plants
    const fetchMFGPlants = async () => {
      setLoading(true);
      try {
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMfgPlants`;
        const res = await axios.get(url);
        const plants = res.data?.MfgPlantsDetails ? res.data?.MfgPlantsDetails : [];
        setMFGPlantListLocal(plants);
        if (setMFGPlantList) {
          setMFGPlantList(plants);
        }
        if (setAllMFGPlantList) {
          setAllMFGPlantList(plants);
        }
      } catch (err) {
        console.error('Error fetching MFG plants:', err);
        setMFGPlantListLocal([]);
        if (setMFGPlantList) {
          setMFGPlantList([]);
        }
        if (setAllMFGPlantList) {
          setAllMFGPlantList([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMFGPlants();
  }, [setMFGPlantList, setAllMFGPlantList]);

  // Use filtered list from parent if provided, otherwise use local list
  const displayList = filteredMFGPlantList && filteredMFGPlantList.length >= 0 
    ? filteredMFGPlantList 
    : mfgPlantList;

  const getDisplayValue = () => {
    if (
      selectedMfgPlantIds.length === displayList.length &&
      selectedMfgPlantIds.length !== 1
    ) {
      return 'All';
    } else if (
      selectedMfgPlantIds.length === displayList.length &&
      selectedMfgPlantIds.length === 1
    ) {
      const result = displayList.filter(
        (val) => selectedMfgPlantIds[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return 'All';
      }
    } else if (selectedMfgPlantIds.length === 1) {
      const result = displayList.filter(
        (val) => selectedMfgPlantIds[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return 'All';
      }
    }
    return 'Multiple selection';
  };

  return (
    <React.Fragment className={classes.filterFieldValue}>
      <FormControl className={classes.formControl} fullWidth>
        <Select
          labelId='mfg-plant-filter'
          id='mfg-plant-filter-id'
          multiple
          // value={selectedMFGPlantList.length > 0 ? selectedMFGPlantList : []}
          value={selectedMfgPlantIds.length > 0 ? selectedMfgPlantIds : []}
          // onChange={handleSelectMFGPlant}
          onChange={handleSelect}
          onClose={(e)=>
            handleSelectMFGPlant({...e, target:{...e.target,value:selectedMfgPlantIds}})
          }
          variant='outlined'
          displayEmpty
          renderValue={(selected) =>
            selected.length === 0 ? 'All' : getDisplayValue()
          }
          classes={{
            outlined: classes.outlined,
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                overflowY: 'auto',
              },
            },
          }}
        >
          <MenuItem value='All'>
            <Checkbox
              checked={
                selectedMfgPlantIds.length === displayList.length &&
                displayList.length > 0
              }
            />
            <ListItemText primary='All' />
          </MenuItem>
          {loading ? (
            <MenuItem disabled>
              <ListItemText primary='Loading...' />
            </MenuItem>
          ) : (
            displayList.map((plant, i) => (
              <MenuItem key={i} value={plant.aslNumber}>
                <Checkbox checked={selectedMfgPlantIds.includes(plant.aslNumber)} />
                <ListItemText
                  primary={`${plant.mfgPlantShortName}`}
                />
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

export default MFGPlantFilter;
